/**
 * Direct-Load Project Overlay client controller.
 *
 * When a visitor lands on a project URL fresh (refresh, shared link,
 * search engine), PHP renders the project markup INSIDE
 * `#lay-project-overlay` with `data-direct-load="1"` and exposes
 * `layData.direct_load_underlay = { url, type, id, can_lazy_load }`.
 *
 * This controller orchestrates the JS side:
 *   • bootstrapIfNeeded()  — runs BEFORE the first newpageshown emit;
 *                            delegates to projects_overlays.bootstrapDirectLoad
 *                            which mimics animateIn end-state.
 *   • isActive()           — read after bootstrap to decide whether the
 *                            initial newpageshown emits with
 *                            isProjectOverlay=true (vs. the default false).
 *   • fetchUnderlay()      — runs AFTER the first newpageshown emit;
 *                            AJAX-fetches the configured underlay via
 *                            get_laytheme_layout, replaces the
 *                            .lay-direct-load-underlay-placeholder, and
 *                            emits a SECOND newpageshown for the
 *                            underlay scope so its listeners init.
 *
 * The two newpageshown fires are scope-disjoint thanks to the RED-pass
 * scope-safety fixes — each scope's listeners only touch their own
 * .lay-content root.
 */

import projects_overlays from './projects_overlays'

let active = false
let info = null

const bootstrapIfNeeded = function () {
	info = window.layData && window.layData.direct_load_underlay ? window.layData.direct_load_underlay : null
	if (!info) {
		active = false
		return false
	}
	active = projects_overlays.bootstrapDirectLoad(info)
	return active
}

const isActive = function () {
	return active
}

const fetchUnderlay = function () {
	if (!active || !info || !info.can_lazy_load || !info.id) return
	if (!window.jQuery || !window.layData || !window.layData.ajax_url) return

	jQuery.ajax({
		url: window.layData.ajax_url,
		data: {
			action: 'get_laytheme_layout',
			id: info.id,
			type: info.type,
			password: '',
			is_project_overlay: 'false',
		},
		type: 'post',
		success: onUnderlayLoaded,
	})
}

const onUnderlayLoaded = function (json) {
	let result
	try {
		result = JSON.parse(json)
	} catch (e) {
		return
	}
	if (!result || !result.layout || !result.layout.markup) return

	const $placeholder = jQuery('body > .lay-direct-load-underlay-placeholder')
	if ($placeholder.length === 0) {
		// Placeholder might have been swallowed (e.g. by a PHP filter).
		// Insert before the overlay so it sits underneath visually.
		jQuery(result.layout.markup).insertBefore('#lay-project-overlay')
	} else {
		$placeholder.replaceWith(result.layout.markup)
	}

	// Background media (the optional fixed-position layer behind project
	// overlays) — mirror the SPA-flow handling in layout_controller.js.
	if (result.layout.project_overlay_background_media) {
		jQuery(result.layout.project_overlay_background_media).insertBefore('#lay-project-overlay')
	}

	// Fire newpageshown for the underlay scope. Scope-aware listeners
	// init for the underlay without disturbing the active overlay's scope.
	const underlayLayoutObj = result.layout.layoutObj || {}
	const underlayObj = { id: info.id, type: info.type }
	window.laytheme.emit('newpageshown', underlayLayoutObj, info.type, underlayObj, { isProjectOverlay: false })

	// From here on the underlay is real DOM, so the close button can use the
	// normal SPA reveal path. Until this point projects_overlays keeps a hard
	// navigation fallback to avoid revealing the empty direct-load placeholder.
	projects_overlays.clearDirectLoadHardNavMode()
}

const direct_load_controller = {
	bootstrapIfNeeded,
	isActive,
	fetchUnderlay,
}

export default direct_load_controller
